import moment from 'moment';
import * as types from '@/store/mutation-types';
import todoItemApi from '@/store/todoItem/todoItemApi';
import { logAction } from '@/store/logActions';
import { editingAllowed } from '@/store/actions';
import log from '@/logger';

export const getTodoItem = (ctx, id) => {
  log.debug('actions:getTodoItem', id);

  return todoItemApi.getTodoItem(id);
};

export const loadSelectedPartTodoItems = async ({ state, dispatch, commit }) => {
  let part = state.selectedPart;
  if (!part) {
    console.log('no part selected');
    commit(types.setSelectedPartTodoItems, []);
    return;
  }
  await dispatch('getTodoItems', { projectId: part.projectId, partId: part._id })
    .then((items) => {
      commit(types.setSelectedPartTodoItems, items);
    })
    .catch((e) => {
      console.error(e);
    });
};

export const getTodoItems = (ctx, { projectId, partId }) => {
  return todoItemApi.getTodoItems(projectId, partId);
};

export const deleteTodoItem = async ({ commit, state }, todoItem) => {
  log.debug('actions:deleteTodoItem', todoItem);

  if (!editingAllowed(state)) {
    return;
  }
  logAction({ commit, state }, { project: state.currentProject, object: todoItem, reason: 'Deleted TodoItem' });
  commit(types.setTodoItemProperties, { updateTodoItem: todoItem, newTodoItemProperties: { archived: true } });
  await todoItemApi
    .saveTodoItem(todoItem)
    .then((savedTodoItem) => {
      commit(types.setTodoItemProperties, { updateTodoItem: todoItem, newTodoItemProperties: savedTodoItem });
      commit(types.deleteTodoItem, { todoItem });
    })
    .catch((e) => {
      log.error('todoItemActions:deleteTodoItem, saving TodoItem', e);
      commit(types.setSyncStatus, { status: 'Error', live: 0, message: 'Database Error occurred', count: 1 });
    });
};

export const addTodoItem = ({ commit, state }, { projectId, partId, newTodoItemProperties }) => {
  log.debug('actions:addTodoItem', newTodoItemProperties);

  if (!editingAllowed(state)) {
    return;
  }

  return todoItemApi
    .createTodoItem(projectId, partId, newTodoItemProperties)
    .then(async (todoItem) => {
      // setTodoItemProperties({commit, state}, {updateTodoItem: todoItem, newTodoItemProperties: newTodoItemProperties});
      commit(types.addTodoItem, { newTodoItem: todoItem });
      logAction({ commit, state }, { project: state.currentProject, object: todoItem, reason: 'Added TodoItem' });

      return todoItem;
    })
    .catch((e) => {
      log.error('todoItemActions:addTodoItem', e);
      commit(types.setSyncStatus, { status: 'Error', live: 0, message: 'Database Error occurred', count: 1 });
    });
};

export const saveTodoItemProperties = ({ commit, state }, update) => {
  log.debug('actions:saveTodoItemProperties', update);

  if (!editingAllowed(state)) {
    return Promise.resolve();
  }

  logAction(
    { commit, state },
    {
      project: state.currentProject,
      object: update.updateTodoItem,
      reason: 'Updated TodoItem Properties',
      update: update.newTodoItemProperties,
    }
  );

  if (update.newTodoItemProperties.checked && update.newTodoItemProperties.checked === true) {
    update.newTodoItemProperties.checkedBy = state.loggedInPerson._id;
    update.newTodoItemProperties.checkedAt = moment().format();
  }
  setTodoItemProperties({ commit, state }, update);

  return todoItemApi
    .saveTodoItem(update.updateTodoItem)
    .then((savedTodoItem) => {
      update.newTodoItemProperties = savedTodoItem;

      commit(types.setTodoItemProperties, update);
      return savedTodoItem;
    })
    .catch((e) => {
      log.error('Error when saving todoItem', e);
      commit(types.setSyncStatus, { status: 'Error', live: 0, message: 'Database Error occurred', count: 1 });
    });
};

export const syncTodoItem = ({ commit, state }, todoItem) => {
  if (
    state.selectedPart &&
    todoItem.partId === state.selectedPart._id &&
    todoItem.projectId === state.selectedPart.projectId
  ) {
    let foundItem = state.selectedPartTodoItems.find((i) => {
      return i._id === todoItem._id;
    });

    if (foundItem) {
      commit(types.setTodoItemProperties, { updateTodoItem: foundItem, newTodoItemProperties: todoItem });
    } else {
      commit(types.addTodoItem, { newTodoItem: todoItem });
    }
  }
};

export const setTodoItemProperties = ({ commit, state }, update) => {
  if (!editingAllowed(state)) {
    return;
  }

  commit(types.setTodoItemProperties, update);
};



// WEBPACK FOOTER //
// ./src/store/todoItem/todoItemActions.js